/**
 * Audience Selection Defaults
 * Default values and constants for audience selection
 */

export const AUDIENCE_DEFAULTS = {
    PAGE_SIZE: 5,
    INITIAL_PAGE: 1,
} as const;

export const EMPTY_STATE_MESSAGES = {
    NO_TAGS: {
        header: 'Add tags to continue',
        subheader: 'Include tags to segment your customers and personalize emails',
    },
    NO_MATCHES: {
        header: 'No matches for this tag!',
        subheader: 'Try a different tag or create a new one',
    },
} as const;

export const EVERYONE_TAG_NAME = 'Everyone';
